import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePostGetPackingSlipListMutation } from '../../../../store/api/packingSlip';
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from '../../../../Core/Export/ExportCSV';
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";


const Lpntable = ({ deliveryNoteId }) => {
    const navigate = useNavigate();
	const { screenHeight, screenScaling,pageSize } = useScreenHeight();

    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [packingSlipData, setPackingSlipData] = useState({ packing_slip_list: [], total_no_of_records: 0 });
    const [packingSlipDataApi] = usePostGetPackingSlipListMutation();
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [deleteDoc] = useDeleteDocMutation();

const filtersConfig = [
    { name: 'siNo', label: 'S. No', width: '5%', type: 'number' },
    { name: 'name', label: 'No', width: '12.7%', type: 'text' },
    { name: 'delivery_note', label: 'Delivery Note', width: '12.5%', type: 'text' },
    { name: 'from_case_no', label: 'From Package No.', type: 'text', width: '11%' },
    { name: 'to_case_no', label: 'To Package No.', type: 'text', width: '11%' },
    {
        name: 'status',
        label: 'Status',
        width: '10.7%',
        type: 'select',
        options: [
            { value: 'Delivery Note Created', label: 'Delivery Note Created' },
            { value: 'Invoiced', label: 'Invoiced' },
            { value: 'Delivery Note Submitted', label: 'Delivery Note Submitted' },
        ]
    },
    { name: 'creation', label: 'Date', type: 'date', width: '10.7%' },

    { name: 'net_weight_pkg', label: 'Net Weight', type: 'number', width: '10%' },
    { name: 'gross_weight_pkg', label: 'Gross Weight', type: 'number', width: '10%' },
    { name: 'owner', label: 'Owner', type: 'text', width: '12%' },
    { name: 'modified_by', label: 'Modified By', type: 'text', width: '12%' },
    { name: 'sales_order_no', label: 'Sales Order', type: 'text', width: '13%' },
    { name: 'total_received_qty', label: 'Received Qty', type: 'number', width: '10%' },
    { name: 'customer_name', label: 'Customer', type: 'text', width: '14%' },
    { name: 'no_of_lines', label: 'No. of Lines', type: 'number', width: '10%' },
    { name: 'no_of_qty', label: 'Total Qty', type: 'number', width: '10%' }
];


   const [columnsConfig, setColumnsConfig] = useState(() => [
    {
        header: "S. No.",
        name: "S. No.",
        accessor: "siNo",
        width: '5%',
        cellRenderer: (row) => row.siNo,
        sortable: false,
        visible: true
    },
    {
        header: "No",
        name: "Name",
        accessor: "name",
        width: '14.7%',
        sortable: true,
        visible: true
    },
    {
        header: "Delivery Note",
        name: "Delivery Note",
        accessor: "delivery_note",
        width: '12.7%',
        sortable: true,
        visible: true
    },
    {
        header: "From Package No.",
        name: "From Package No.",
        accessor: "from_case_no",
        width: '9%',
        sortable: true,
        visible: true,
        sortFn: (a, b) => parseInt(a.from_case_no) - parseInt(b.from_case_no)
    },
    {
        header: "To Package No.",
        name: "To Package No.",
        accessor: "to_case_no",
        width: '9.7%',
        sortable: true,
        visible: true,
        sortFn: (a, b) => parseInt(a.to_case_no) - parseInt(b.to_case_no)
    },
    {
        header: "Net Weight",
        name: "Net Weight",
        accessor: "net_weight_pkg",
        width: '9%',
        sortable: true,
        visible: false,
        sortFn: (a, b) => parseFloat(a.net_weight_pkg) - parseFloat(b.net_weight_pkg)
    },
    {
        header: "Gross Weight",
        name: "Gross Weight",
        accessor: "gross_weight_pkg",
        width: '9%',
        sortable: true,
        visible: false,
        sortFn: (a, b) => parseFloat(a.gross_weight_pkg) - parseFloat(b.gross_weight_pkg)
    },

    {
        header: "Owner",
        name: "Owner",
        accessor: "owner",
        width: '12%',
        sortable: true,
        visible: false
    },
    {
        header: "Modified By",
        name: "Modified By",
        accessor: "modified_by",
        width: '12%',
        sortable: true,
        visible: false
    },
    {
        header: "Sales Order",
        name: "Sales Order",
        accessor: "sales_order_no",
        width: '13%',
        sortable: true,
        visible: false
    },
    {
        header: "Received Qty",
        name: "Received Qty",
        accessor: "total_received_qty",
        width: '10%',
        sortable: true,
        visible: false,
        sortFn: (a, b) => parseFloat(a.total_received_qty) - parseFloat(b.total_received_qty)
    },
    {
        header: "Customer",
        name: "Customer",
        accessor: "customer_name",
        width: '14%',
        sortable: true,
        visible: false
    },
    {
        header: "No. of Lines",
        name: "No. of Lines",
        accessor: "no_of_lines",
        width: '10%',
        sortable: true,
        visible: true,
        sortFn: (a, b) => parseInt(a.no_of_lines) - parseInt(b.no_of_lines)
    },
    {
        header: "Total Qty",
        name: "Total Qty",
        accessor: "no_of_qty",
        width: '10%',
        sortable: true,
        visible: true,
        sortFn: (a, b) => parseFloat(a.no_of_qty) - parseFloat(b.no_of_qty)
    },
    {
        header: "Status",
        name: "Status",
        accessor: "status",
        width: '13.7%',
        sortable: true,
        visible: true,
        cellRenderer: (row) => {
            const status = row.status;
            let color;

            switch (status) {
                case 'Delivery Note Created': color = '#65A30D'; break;
                case 'Draft': color = '#6366F1'; break;
                case 'Delivery Note Submitted': color = '#6B21A8'; break;
                case 'Invoiced': color = '#0E7490'; break;
                case 'To Bill': color = '#D97706'; break;
                case 'Completely Picked': color = '#65A30D'; break;
                case 'Cancelled': color = '#EF4444'; break;
                case 'Closed': color = '#E11D48'; break;
                default: color = '#000000';
            }

            return (
                <span
                    style={{
                        backgroundColor: `${color}1A`,
                        color,
                        padding: '4px 10px',
                        borderRadius: '9999px',
                        fontSize: '12px',
                        fontWeight: 500,
                        display: 'inline-block',
                        textTransform: 'capitalize',
                    }}
                >
                    {status}
                </span>
            );
        }
    },
    {
        header: "Date",
        name: "Date",
        accessor: "creation",
        width: '6.7%',
        sortable: true,
        visible: true,
        sortFn: (a, b) => new Date(a.creation) - new Date(b.creation)
    },
    {
        header: "Action",
        name: "Action",
        width: '10%',
        sortable: false,
        accessor : "action",
        visible: true,
        cellRenderer: (row) => (
            <ActionButtonDropdown
                id={row.name}
                onView={() => handleView(row.name)}
                onEdit={() => handleEdit(row.name)}
                onDelete={() => handleDelete(row.name)}
                actions={['view', 'delete']}
            />
        )
    }
]);


    const handleSaveColumns = (selectedKeys) => {
        const updatedColumns = columnsConfig.map(column => ({
            ...column,
            visible: selectedKeys.includes(column.accessor)
        }));
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible), [columnsConfig]);

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            })), [columnsConfig]);

    const handleView = (id) => navigate(`/outbound/outbound-packingslip-view/`, { state: { packing_slip: id } });
    const handleEdit = (id) => navigate(`/inbound/purchaseorder/edit-purchase-order/`, { state: { PurchaseId: id } });

    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)

    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this Packing Slip?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "Packing Slip", name: delSelectedId }).unwrap()
            setDelmessage(`Packing Slip ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(true);
                setDelDone(false)
                getData();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Packing Slip!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.trim();
                            //remove trailing punctuation
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };

    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);
    const actionButtons = [
        {
           className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
      className: "custom-btn-00989 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "FiPlus",
      iconSize: 12,
      children: "Create Packing Slip",
      to: "/outbound/outbound-create-packingslip",
    }
    ];

    const getData = async () => {
        setLoading(true);
        try {
					const filteredSearchInput = Object.entries(filters).reduce(
						(acc, [key, value]) => {
							if (value !== "" && value !== undefined && value !== null) {
								acc[key] = value;
							}
							return acc;
						},
						{}
					);
					const siNoFilter = filteredSearchInput.siNo;
					const isSiNoFilterActive =
						siNoFilter !== undefined && siNoFilter !== "";
					// STEP 3: If filtering by siNo, jump to that page
					const targetPage = isSiNoFilterActive
						? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
						: currentPage;
					const payload = {
						start: pageSize * (targetPage - 1),
						page_length: pageSize,
						...(Object.keys(filteredSearchInput).length > 0 && {
							search_input: {
								packing_slip_no: filteredSearchInput.No || "",
								delivery_note: filteredSearchInput.delivery_note || "",
								status: filteredSearchInput.status || "",
								from_case_no: filteredSearchInput.from_case_no || "",
								to_case_no: filteredSearchInput.to_case_no || "",
							},
						}),
					};

					const response = await packingSlipDataApi(payload);
					const rawData = response?.data?.data?.packing_slip_list;
					// STEP 4: Assign global serial numbers
					const numberedData = rawData.map((item, index) => ({
						...item,
						siNo: index + 1 + pageSize * (targetPage - 1),
					}));

					// STEP 5: If siNo is used, filter client-side
					const finalData = isSiNoFilterActive
						? numberedData.filter(
								(item) => item.siNo === parseInt(siNoFilter, 10)
						  )
						: numberedData;
            setPackingSlipData({
                packing_slip_list: finalData || [],
                total_no_of_records: response?.data?.data?.total_no_of_records || 0
                    });
				} catch (error) {
            console.error("Error fetching packing slips:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };

    useEffect(() => {
		if (pageSize > 0) getData();
	}, [currentPage, filters, pageSize, screenHeight, screenScaling]);
    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Outbound" },
                    { label: "PackingSlip List", style: { color: '#270B79' } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && (
                    <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                )}

                {showColumnConfig && (
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Packing Slip"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["id", "status", "action","name","creation"]}
                    />
                )}

                <Table
                    columns={visibleColumns}
                    data={packingSlipData.packing_slip_list}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={packingSlipData.total_no_of_records}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />}
                {showExportPopup && (
                    <ExportCSV
                        doctype="Packing Slip"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>
        </div>
    );
};

export default Lpntable;